module.exports = __webpack_public_path__ + "static/media/DSC_0109.0a6f5894.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0109.jpg
// module id = 556
// module chunks = 0